import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import * as jose from 'jose';

// internal
import { token as tokenAction } from 'core-request';
import { useClientStore } from '../../store/client';
import { useProjectStore } from '../../store/project';

const Callback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const redirect_uri = searchParams.get('redirect_uri');

  const clientStore = useClientStore((state) => ({
    setAuthClient: state.setAuthClient,
  }));

  useEffect(() => {
    if (token) {
      tokenAction.setRefresh(token as string);

      if (redirect_uri) {
        const link = jose.decodeJwt(token).aud || '';
        const segments = new URL(link.toString()).pathname.split('/').filter(Boolean);
        const newClient = segments.length ? segments[segments.length - 1] : '';

        clientStore.setAuthClient(newClient);

        if (newClient !== useProjectStore.getState().client) {
          useProjectStore.getState().reset();
          navigate('/main/project', { replace: true });
        } else {
          window.location.replace(redirect_uri as string);
        }
      } else {
        navigate('/', { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return '';
};

export default Callback;
